import { db } from '@/vendors/firebase/firebase';
import UserProfile from '@/entities/UserProfile';

export default {
  async getUser(userId) {
    const doc = await db.collection('users').doc(userId).get();
    if (!doc) { return null; }
    return new UserProfile(doc.data());
  },
};
